module.exports = __webpack_public_path__ + "media/images/welcome_bg_night-bdda34c98619e4ddfbee55d0aa47426a.png";